export default __webpack_public_path__ + "static/media/Kanha-Pench-National-park.fb134fa4.jpg";